export default __webpack_public_path__ + "static/media/current_location.f5985ac4.svg";